import React, { useState } from "react";
import { LogsContainer, ParentContainer, TabsContainer } from "./Logs.styled";
import { useNavigate } from "react-router-dom";
import Execution from "./pages/Execution";
import Audit from "./pages/Audit";
import { Tabs } from "@ann/web-components";
import { ExecutionProvider } from "../../../../context/ExecutionContext";

const Logs = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();

  const handleTabChange = (index) => {
    setSelectedTab(index);
    if (index === 0) {
      navigate("");
    } else {
      navigate("audit");
    }
  };

  return (
    <ParentContainer>
      <LogsContainer>
      <Tabs
        defaultIndex={0}
        selectedIndex={selectedTab}
        onTabChange={handleTabChange}
      >
        <TabsContainer>
          <Tabs.List>
            <Tabs.Tab size="small" index={0}>
              Execution Log
            </Tabs.Tab>
            <Tabs.Tab size="small" index={1}>
              Audit Log
            </Tabs.Tab>
          </Tabs.List>
        </TabsContainer>

        <Tabs.Panel index={0}>
          <ExecutionProvider>
            <Execution />
          </ExecutionProvider>
        </Tabs.Panel>
        <Tabs.Panel index={1}>
          <Audit />
        </Tabs.Panel>
      </Tabs>
      </LogsContainer>
    </ParentContainer>
  );
};

export default Logs;
